import ReportData from './ReportData';

export default ReportData;
